import api from './api';

/**
* @returns {Promise<{
*   items: {
*     image_id: string,
*     created_at: string,
*     updated_at: string
*   }[],
*   total: number,
*   page: number,
*   perPage: number,
*   totalPages: number
* }>}
* @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Assets-GetImages
*/
export default async function getAllImageAssets({
  search,
  orderBy,
  order,
  page,
  perPage,
  version
}) {
  const queryParams = new URLSearchParams();

  if (search) queryParams.append('image_id', search);
  if (orderBy) queryParams.append('orderBy', orderBy);
  if (order) queryParams.append('order', order);
  if (page) queryParams.append('page', page);
  if (perPage) queryParams.append('perPage', perPage);
  if (version) queryParams.append('version', version);

  const { data } = await api.get(`assets/images?${queryParams.toString()}`);
  return data;
}